import { render, staticRenderFns } from "./DonutChart01.vue?vue&type=template&id=32ae0be1&scoped=true"
import script from "./DonutChart01.vue?vue&type=script&lang=js"
export * from "./DonutChart01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae0be1",
  null
  
)

export default component.exports